module.exports = __webpack_public_path__ + "team.png?fe58e5ae7d77b6a7f92d4b07c0dc5fac";


//////////////////
// WEBPACK FOOTER
// ./public/img/team/team.png
// module id = 522
// module chunks = 4